import { ref } from 'vue';
import { useFetch } from './useFetch';
import type { DigitalVendorBoardPage, DigitalVendorHealthDashboard } from '@apparatix/types';

export const useDigitalVendorHealth = (healthUrl: string, unregisteredBoardUrls: Record<string, string>) => {
  const health = ref<DigitalVendorHealthDashboard | null>(null);
  const isLoading = ref(false);
  const didError = ref(false);
  const { get } = useFetch();

  const loadHealth = async () => {
    isLoading.value = true;
    didError.value = false;

    try {
      const response = await get<DigitalVendorHealthDashboard>(healthUrl);
      health.value = response;
      didError.value = !response;
    } catch (error) {
      console.error('Unable to load digital vendor health.', error);
      health.value = null;
      didError.value = true;
    } finally {
      isLoading.value = false;
    }
  };

  const loadUnregisteredBoards = async (vendorCode: string, page = 1, perPage = 25): Promise<DigitalVendorBoardPage | null> => {
    const boardUrl = unregisteredBoardUrls[vendorCode];

    if (!boardUrl) return null;

    const url = new URL(boardUrl, window.location.origin);
    url.searchParams.set('page', page.toString());
    url.searchParams.set('perPage', perPage.toString());

    return get<DigitalVendorBoardPage>(url.toString());
  };

  return {
    health, isLoading, didError, loadHealth, loadUnregisteredBoards,
  };
};
